module.exports = __webpack_public_path__ + "helix-info.jpg?0536f05035f70c3d358650be9d160bea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/helix-info.jpg
// module id = 259
// module chunks = 0